<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Task Tables Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Analyses" active>
        <h3>Analyses</h3>
        <analysis-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :task_type="'prep'"
          :show_columns="[
            'name',
            'modus_name',
            'extraction_method',
            'measurement_method',
          ]"
        />
      </b-tab>
      <b-tab title="Instruments">
        <h3>Instruments</h3>
        <instrument-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :task_instruments="prep_task.instruments.map(({ id }) => id)"
          :show_columns="['name', 'abbrev']"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AnalysisServerTable from "@/components/lab/analysis/AnalysisServerTable";
import InstrumentServerTable from "@/components/lab/instrument/InstrumentServerTable";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "PrepTaskDetailCardstack",
  components: {
    AnalysisServerTable,
    InstrumentServerTable,
  },
  props: {
    prep_task: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      analyte_collection: null,
      sample_type_collection: null,
    };
  },
  methods: {
    async init() {
      const payload = {
        message: this.$bvToast,
        sort: [
          {
            logic: "sortAddAsc",
            field: "name",
          },
        ],
        limit: "all",
      };

      this.sample_type_collection = await getCollection({
        ...payload,
        collection_type: "sample_type",
      });
      this.analyte_collection = await getCollection({
        ...payload,
        collection_type: "analyte",
      });

      this.loading = false;
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>
